import { FormattedMessage, defineMessages } from 'react-intl';

import { Blockquote } from '@sorare/core/src/atoms/layout/Blockquote';

const messages = defineMessages({
  aboveMarketWarning: {
    defaultMessage:
      'This amount is much higher than the recorded past transactions for this player.',
  },
});

export const AboveMarketWarning = () => (
  <Blockquote variant="red">
    <FormattedMessage {...messages.aboveMarketWarning} />
  </Blockquote>
);
